<!-- Sales Report Modal Template -->
<div class="modal-overlay overlay-z2000" *ngIf="isOpen" (click)="onClose()">
  <div class="modal-content report-modal-content" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>Sales Report - {{ company?.company }}</h2>
      <div class="header-actions">
        <button *ngIf="showPdfActions" class="action-btn" (click)="printReport()">Print</button>
        <button *ngIf="showPdfActions" class="action-btn pdf-btn" (click)="saveReportPdf()">Save PDF</button>
        <button class="close-btn-static" (click)="onClose()">&times;</button>
      </div>
    </div>
    
    <div class="modal-body scrollable-modal-body">
      <div class="live-report-content">
        <!-- Header Card -->
        <div class="card header-card">
          <div class="company-info">
            <h2>{{ company?.company }}</h2>
            <p class="subtle">{{ company?.address }}</p>
          </div>
          <div class="date-info">
            <div class="info-item" *ngIf="brandName"><label>Brand:</label><span data-testid="srm-brand">{{ brandName }}</span></div>
            <div class="info-item"><label>Statement Period:</label><span data-testid="srm-period">{{ displayPeriod }}</span></div>
            <div class="info-item" *ngIf="selectedBranchFilter !== 'All'"><label>Branch:</label><span>{{ selectedBranchFilter }}</span></div>
          </div>
        </div>

        <!-- Branch filter -->
        <div class="branch-filter-row" *ngIf="availableBranches.length > 1">
          <label for="srmBranchFilter">Branch</label>
          <select id="srmBranchFilter" class="branch-select" data-testid="srm-branch-filter" [(ngModel)]="selectedBranchFilter" (ngModelChange)="applyBranchFilter()">
            <option value="All">All branches</option>
            <option *ngFor="let b of availableBranches" [value]="b">{{ b }}</option>
          </select>
        </div>

        <!-- Summary Grid with Revenue & Date Range -->
        <div class="summary-grid">
          <div class="card summary-card">
            <label>Total Revenue (USD)</label>
            <span class="value income">{{ totalRevenue | currency:'USD':'symbol':'1.2-2' }}</span>
            <div class="report-date-range-sub">
              <span class="range-label">Report Date Range:</span>
              <span class="range-val">{{ dateRange.display }}</span>
            </div>
          </div>
        </div>

        <!-- Monthly Breakdown Table -->
        <div class="monthly-table-container">
          <table class="monthly-breakdown-table">
            <thead>
              <tr>
                <th class="text-center th-store">StoreID</th>
                <th class="text-center th-device">Device ID</th>
                <th class="text-center th-name">Device Name</th>
                <th class="text-center th-paper">Paper</th>
                <th class="text-center th-paytype">Payment Type</th>
                <th class="text-center th-sales">Sales</th>
                <th class="text-center th-groupsum">Group Sum</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="isLoadingDetails">
                <td colspan="7" class="text-center py-4">
                  <div class="spinner spinner-center"></div>
                  <span class="loading-text">Loading sales report...</span>
                </td>
              </tr>

              <tr *ngIf="!isLoadingDetails && loadError">
                <td colspan="7" class="text-center py-4 error-state" data-testid="srm-error" role="alert">Could not load the sales report. Close this window and try again.</td>
              </tr>

              <ng-container *ngIf="!isLoadingDetails && !loadError">
                <ng-container *ngFor="let row of filteredDetailRows">
                  <!-- Sub-row 1: Card -->
                  <tr class="device-row-top">
                    <td rowspan="2" class="text-center fw-600 cell-merged">{{ row.storeId }}</td>
                    <td rowspan="2" class="text-center cell-merged">{{ row.deviceId }}</td>
                    <td rowspan="2" class="text-center cell-merged">{{ row.deviceName }}</td>
                    <td rowspan="2" class="text-center cell-merged">{{ row.paper | number }}</td>
                    <td class="text-center font-medium">Card</td>
                    <td class="text-right font-num">{{ row.card.sales | currency:'USD':'symbol':'1.2-2' }}</td>
                    <td rowspan="2" class="text-center fw-600 cell-merged cell-groupsum">{{ row.groupSum | currency:'USD':'symbol':'1.2-2' }}</td>
                  </tr>
                  <!-- Sub-row 2: Cash -->
                  <tr class="device-row-bottom">
                    <td class="text-center font-medium">Cash</td>
                    <td class="text-right font-num">{{ row.cash.sales | currency:'USD':'symbol':'1.2-2' }}</td>
                  </tr>
                </ng-container>

                <tr *ngIf="filteredDetailRows.length === 0">
                  <td colspan="7" class="empty-state text-center py-4">No report records found for this period.</td>
                </tr>
              </ng-container>
            </tbody>
            <tfoot *ngIf="!isLoadingDetails && filteredDetailRows.length > 0">
              <tr class="total-sum-row">
                <td colspan="3" class="text-center fw-bold">Total Sum</td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-right fw-bold">{{ totals.sales | currency:'USD':'symbol':'1.2-2' }}</td>
                <td class="text-center fw-bold">{{ totals.groupSum | currency:'USD':'symbol':'1.2-2' }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        
        <!-- Attached Images Pages -->
        <ng-container *ngIf="imageAttachments?.length || imageUrl">
          <div class="attached-images-section">
            <h3 class="attached-images-title">Attached Documents</h3>
            <div *ngIf="imageUrl && !imageAttachments?.length" class="attached-image-page">
              <div class="attached-image-container">
                <img [src]="imageUrl" crossorigin="anonymous" referrerpolicy="no-referrer" alt="Attached Report Document">
              </div>
            </div>
            <div *ngFor="let img of imageAttachments" class="attached-image-page">
              <div class="attached-image-container">
                <img [src]="img.url" crossorigin="anonymous" referrerpolicy="no-referrer" [alt]="img.name">
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Hidden PDF Template for Modal -->
<div id="sales-report-pdf-modal-wrapper" *ngIf="isOpen" style="position: absolute; left: -5000px; top: 0; visibility: visible;">
  <div id="sales-pdf-content-modal" class="pdf-wrapper">
    <div class="pdf-header-panel">
      <div class="card header-card">
        <div class="company-info">
          <h2>{{ company?.company }}</h2>
          <p class="subtle">{{ company?.address }}</p>
        </div>
        <div class="date-info">
          <div class="info-item" *ngIf="brandName"><label>Brand:</label><span>{{ brandName }}</span></div>
          <div class="info-item"><label>Statement Period:</label><span>{{ displayPeriod }}</span></div>
          <div class="info-item" *ngIf="selectedBranchFilter !== 'All'"><label>Branch:</label><span>{{ selectedBranchFilter }}</span></div>
        </div>
      </div>

      <div class="summary-grid">
        <div class="card summary-card">
          <label>Total Revenue (USD)</label>
          <span class="value income">{{ totalRevenue | currency:'USD':'symbol':'1.2-2' }}</span>
          <div class="report-date-range-sub">
            <span class="range-label">Report Date Range:</span>
            <span class="range-val">{{ dateRange.display }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Monthly Breakdown Table for PDF -->
    <div class="monthly-table-container">
      <table class="monthly-breakdown-table pdf-table">
        <thead>
          <tr>
            <th class="text-center th-store">StoreID</th>
            <th class="text-center th-device">Device ID</th>
            <th class="text-center th-name">Device Name</th>
            <th class="text-center th-paper">Paper</th>
            <th class="text-center th-paytype">Payment Type</th>
            <th class="text-center th-sales">Sales</th>
            <th class="text-center th-groupsum">Group Sum</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of filteredDetailRows">
            <!-- Sub-row 1: Card -->
            <tr class="device-row-top">
              <td rowspan="2" class="text-center fw-600 cell-merged">{{ row.storeId }}</td>
              <td rowspan="2" class="text-center cell-merged">{{ row.deviceId }}</td>
              <td rowspan="2" class="text-center cell-merged">{{ row.deviceName }}</td>
              <td rowspan="2" class="text-center cell-merged">{{ row.paper | number }}</td>
              <td class="text-center font-medium">Card</td>
              <td class="text-right font-num">{{ row.card.sales | currency:'USD':'symbol':'1.2-2' }}</td>
              <td rowspan="2" class="text-center fw-600 cell-merged cell-groupsum">{{ row.groupSum | currency:'USD':'symbol':'1.2-2' }}</td>
            </tr>
            <!-- Sub-row 2: Cash -->
            <tr class="device-row-bottom">
              <td class="text-center font-medium">Cash</td>
              <td class="text-right font-num">{{ row.cash.sales | currency:'USD':'symbol':'1.2-2' }}</td>
            </tr>
          </ng-container>

          <tr *ngIf="filteredDetailRows.length === 0">
            <td colspan="7" class="empty-state text-center py-4">No report records found for this period.</td>
          </tr>
        </tbody>
        <tfoot *ngIf="filteredDetailRows.length > 0">
          <tr class="total-sum-row">
            <td colspan="3" class="text-center fw-bold">Total Sum</td>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-right fw-bold">{{ totals.sales | currency:'USD':'symbol':'1.2-2' }}</td>
            <td class="text-center fw-bold">{{ totals.groupSum | currency:'USD':'symbol':'1.2-2' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Attached Images Pages -->
    <ng-container *ngIf="imageAttachments?.length || imageUrl">
      <div class="pdf-page-break" style="page-break-before: always; margin-top: 20px;"></div>
      <div class="attached-images-section">
        <div *ngIf="imageUrl && !imageAttachments?.length" class="attached-image-page">
          <div class="attached-image-container">
            <img [src]="imageUrl" crossorigin="anonymous" referrerpolicy="no-referrer" alt="Attached Report Document">
          </div>
        </div>
        <div *ngFor="let img of imageAttachments" class="attached-image-page">
          <div class="attached-image-container">
            <img [src]="img.url" crossorigin="anonymous" referrerpolicy="no-referrer" [alt]="img.name">
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
